import React from 'react';
import { ProfileAvatar } from 'pages/Profile/components';

export interface Props {
  image?: string;
  name: string;
  owner: string;
  type?: any;
}

function CardAuthor(props: Props) {
  const { name, owner, image, type } = props;

  return (
    <div className="mt-2 flex">
      <div className="h-10 w-10 mr-3">
        <ProfileAvatar size={40} avatarFiles={image} />
      </div>
      <div>
        <p className="font-roboto font-normal text-xs leading-5 tracking-[0.25px] text-[#0a0a0a] m-0 w-full overflow-hidden whitespace-nowrap text-ellipsis">
          {name}
        </p>
        <p className="font-roboto font-normal text-xs leading-5 tracking-[0.25px] text-[#757575] m-0 w-full overflow-hidden whitespace-nowrap text-ellipsis">
          {owner}
        </p>
      </div>
    </div>
  );
}

export default CardAuthor;
